import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LandingNav from '../components/landing/LandingNav';
import Hero from '../components/landing/Hero';
import LandingFooter from '../components/landing/LandingFooter';
import {
  PropertiesSection,
  RentalsSection,
  TenantsSection,
} from '../components/landing/FeatureSections';
import PricingSection from '../components/landing/PricingSection';
import ContactSection from '../components/landing/ContactSection';

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    document.title = 'Takarah — Propiedades, clientes y rentas en un solo lugar';
    if (location.pathname === '/rentas') {
      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
      document
        .getElementById('rentas')
        ?.scrollIntoView?.({ behavior: reducedMotion ? 'auto' : 'smooth' });
    }
  }, [location.pathname]);

  return (
    <div className="min-h-[100dvh] bg-gradient-to-b from-[#F5F0E8] to-[#EFE9DF] text-[#141414]">
      <LandingNav />
      <Hero />
      <PropertiesSection />
      <RentalsSection />
      <TenantsSection />
      <PricingSection />
      <ContactSection />
      <LandingFooter />
    </div>
  );
}
